import { render } from "./GoogleSearchComponent.vue?vue&type=template&id=7f8f72e0&scoped=true"
import script from "./GoogleSearchComponent.vue?vue&type=script&lang=js"
export * from "./GoogleSearchComponent.vue?vue&type=script&lang=js"

import "./GoogleSearchComponent.vue?vue&type=style&index=0&id=7f8f72e0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8f72e0"]])

export default __exports__